import { useEffect, useState } from 'react';
import * as bi from 'react-bootstrap-icons';
import { IClientPassengerBrief } from '@bustickus/models-client';
import { Button, Flex, Loader, Modal, Scroll } from 'components';
import { handleAuthError } from 'common/handlers';
import { ApiPassengers } from 'common/api';
import { PassengerCard } from '..';
import './style.scss';
import { ModalAddPassenger } from 'shared/components';

interface IProps {
  onClose: () => void;
  onSelect: (passenger: IClientPassengerBrief) => void;
  needPassport: boolean;
  needForeignPassport: boolean;
  visaIds: string[];
  date: Date;
  selectedPassengers: IClientPassengerBrief[];
}

function ModalSelectPassenger(props: IProps) {
  const [passengers, setPassengers] = useState<IClientPassengerBrief[] | null>(null);
  const [addPassengerModal, setAddPassengerModal] = useState<boolean>(false);

  useEffect(() => {
    loadPassengers();
  }, []);

  const loadPassengers = async () =>
    handleAuthError(async () => {
      const passengersAll = await ApiPassengers.getInstance().getAll(
        props.needPassport,
        props.needForeignPassport,
        props.date,
        props.visaIds
      );
      setPassengers(passengersAll.filter((x) => !props.selectedPassengers.find((y) => y.id === x.id)));
    });

  const handlePassengerCreated = () => {
    setPassengers(null);
    loadPassengers();
    setAddPassengerModal(false);
  };

  return (
    <Modal
      header='Выбор пассажира'
      onClose={props.onClose}
    >
      {addPassengerModal && (
        <ModalAddPassenger
          onClose={() => setAddPassengerModal(false)}
          onSaved={handlePassengerCreated}
        />
      )}

      <div className='select-passenger-modal-cnt-7dqt'>
        {passengers == null && (
          <Flex
            alignItems='center'
            justifyContent='center'
            className='passengers-loader-RQuW'
          >
            <Loader
              variant='line'
              size='default'
              color='blue'
            />
          </Flex>
        )}
        {passengers != null && (
          <Scroll padding={3}>
            <Flex
              direction='column'
              gap={10}
            >
              {passengers.map((x) => (
                <PassengerCard
                  key={x.id}
                  passenger={x}
                  onClick={() => props.onSelect(x)}
                />
              ))}

              <Button onClick={() => setAddPassengerModal(true)}>
                <Flex
                  justifyContent='center'
                  alignItems='center'
                  gap={5}
                >
                  <bi.PersonPlus />
                  <span>Новый пассажир</span>
                </Flex>
              </Button>
            </Flex>
          </Scroll>
        )}
      </div>
    </Modal>
  );
}

export default ModalSelectPassenger;
